/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Scholarshiptype200,
  GetApiV1Scholarshiptype401,
  GetApiV1Scholarshiptype500,
  GetApiV1ScholarshiptypeQueryParams,
  GetApiV1ScholarshiptypeQueryResponse,
} from "../../types/scholarshipTypeRegistroController/GetApiV1Scholarshiptype.ts";
import { scholarshipTypeGridItemViewModelPaginatedResponseSchema } from "../scholarshipTypeGridItemViewModelPaginatedResponseSchema.ts";

export const getApiV1ScholarshiptypeQueryParamsSchema = z.object({
  filter: z.optional(z.string()),
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1ScholarshiptypeQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Scholarshiptype200Schema = z.lazy(
  () => scholarshipTypeGridItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Scholarshiptype200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Scholarshiptype401Schema =
  z.any() as unknown as ToZod<GetApiV1Scholarshiptype401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Scholarshiptype500Schema =
  z.any() as unknown as ToZod<GetApiV1Scholarshiptype500>;

export const getApiV1ScholarshiptypeQueryResponseSchema = z.lazy(
  () => getApiV1Scholarshiptype200Schema,
) as unknown as ToZod<GetApiV1ScholarshiptypeQueryResponse>;
